/**
 * Yeppon Warranty Upsell - Cart Integration v5
 * 
 * Bottone compatto sotto ogni line item idoneo.
 * Funziona in cart drawer e cart page.
 * 
 * Allineato a warranty-upsell.js v4.
 * Debug: window.__warrantyCartDebug = true; per log dettagliati.
 */

(function() {
  'use strict';

  var config = window.__warrantyConfig;
  if (!config || !config.tiers || config.tiers.length === 0) return;

  var settings = config.settings || {};
  var accentColor = settings.accent_color || '#0b5d1e';
  var accentEnd = settings.accent_end || '#148a32';

  // Riquadro compatto su una riga (prova chiesta da Danilo il 24/09: il
  // riquadro grande era alto ~140 px e, arrivando dopo, faceva saltare la
  // pagina). Per tornare al grande: cart_banner: 'grande' nella configurazione
  // dello snippet warranty-upsell.
  var compatto = (config.cart_banner || 'compatto') !== 'grande';

  var tiers = config.tiers.slice().sort(function(a, b) { return a.max_price - b.max_price; });
  var warrantyVariantIds = new Set(tiers.map(function(t) { return String(t.variant_id); }));

  var origFetch = window.__warrantyOrigFetch || window.fetch.bind(window);

  // Fix: cart-drawer section ID rilevato dinamicamente dal DOM invece di
  // hardcoded (l'hardcode '28077421658461' si rompeva se la sezione veniva
  // ricreata e cambiava ID, lasciando il drawer vuoto dopo add-to-cart).
  var _cachedCartDrawerSection = null;
  function getCartDrawerSection() {
    if (_cachedCartDrawerSection) return _cachedCartDrawerSection;
    var el = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
    if (el) {
      _cachedCartDrawerSection = el.id.replace(/^shopify-section-/, '');
      return _cachedCartDrawerSection;
    }
    // fallback: rileva dal markup di cart-drawer principale
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      var parent = cd.closest('[id^="shopify-section-"]');
      if (parent) {
        _cachedCartDrawerSection = parent.id.replace(/^shopify-section-/, '');
        return _cachedCartDrawerSection;
      }
    }
    return null;
  }
  // proxy con getter per mantenere compatibilità con il resto del codice
  Object.defineProperty(window, '__wucCartDrawerSection', { get: getCartDrawerSection });
  function CART_DRAWER_SECTION() { return getCartDrawerSection(); }

  function findTier(price) {
    for (var i = 0; i < tiers.length; i++) {
      if (price <= tiers[i].max_price) return tiers[i];
    }
    return null;
  }

  function fp(p) { return '€' + parseFloat(p).toFixed(2).replace('.', ','); }
  function escHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  var excludedTypes = (config.excluded_product_types || []).map(function(t) { return t.toLowerCase(); });
  function isExcludedType(pt) {
    if (!pt) return false;
    var lower = pt.toLowerCase();
    for (var i = 0; i < excludedTypes.length; i++) {
      if (lower.indexOf(excludedTypes[i]) !== -1) return true;
    }
    return false;
  }

  function dbg() {
    if (!window.__warrantyCartDebug) return;
    var args = ['[WarrantyCart]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  // ─── STYLES ───
  var css = `
    .wuc-banner {
      display: flex;
      align-items: center;
      gap: 14px;
      width: 100%;
      max-width: 100%;
      margin: 12px 0 16px;
      padding: 14px 16px;
      background: linear-gradient(135deg, ${accentColor}08, ${accentColor}03);
      border: 1.5px solid ${accentColor}33;
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
    }
    .wuc-banner::before {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 4px; height: 100%;
      background: linear-gradient(180deg, ${accentColor}, ${accentEnd});
    }
    .wuc-ic {
      width: 44px; height: 44px;
      min-width: 44px;
      border-radius: 12px;
      background: linear-gradient(135deg, ${accentColor}, ${accentEnd});
      color: #fff;
      display: flex; align-items: center; justify-content: center;
      font-size: 22px;
      flex-shrink: 0;
      box-shadow: 0 3px 10px ${accentColor}33;
    }
    .wuc-content {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .wuc-title {
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
      line-height: 1.3;
    }
    .wuc-sub {
      font-size: 12.5px;
      color: #666;
      line-height: 1.4;
    }
    .wuc-feats {
      display: flex;
      flex-wrap: wrap;
      gap: 4px 12px;
      margin-top: 4px;
    }
    .wuc-feat {
      font-size: 11px;
      color: #555;
      display: flex;
      align-items: center;
      gap: 5px;
      line-height: 1.4;
    }
    .wuc-feat::before {
      content: '✓';
      color: ${accentColor};
      font-weight: 800;
      font-size: 10px;
    }
    .wuc-price-block {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
      flex-shrink: 0;
      padding-top: 22px;
    }
    .wuc-price {
      font-size: 20px;
      font-weight: 800;
      color: ${accentColor};
      line-height: 1;
      white-space: nowrap;
    }
    .wuc-btn {
      padding: 10px 18px;
      background: linear-gradient(135deg, ${accentColor}, ${accentEnd});
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      transition: all .15s ease;
      box-shadow: 0 2px 10px ${accentColor}33;
      white-space: nowrap;
    }
    .wuc-btn:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 14px ${accentColor}55;
      filter: brightness(1.05);
    }
    .wuc-btn:disabled {
      opacity: .65; cursor: wait;
    }
    .wuc-dismiss {
      position: absolute;
      top: 6px; right: 6px;
      background: #fff; border: 1px solid #d0d0d0; border-radius: 50%;
      color: #555;
      cursor: pointer;
      width: 26px; height: 26px;
      padding: 0;
      display: inline-flex; align-items: center; justify-content: center;
      z-index: 2;
      transition: color .15s ease, background .15s ease, border-color .15s ease;
    }
    .wuc-dismiss svg { display: block; width: 12px; height: 12px; }
    .wuc-dismiss:hover { color: #000; background: #f3f3f3; border-color: #999; }
    .wuc-dismiss:focus-visible {
      outline: 3px solid #0066cc;
      outline-offset: 2px;
      color: #000;
    }
    .wuc-banner-added {
      background: ${accentColor}10;
      border-color: ${accentColor}55;
    }
    .wuc-added-msg {
      display: flex; align-items: center;
      gap: 10px;
      font-size: 14px; font-weight: 600;
      color: ${accentColor};
    }
    .wuc-added-check {
      width: 26px; height: 26px;
      border-radius: 50%;
      background: ${accentColor};
      color: #fff;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px; font-weight: 700;
    }

    /* Mobile / drawer (compatto) */
    @media (max-width: 768px) {
      .wuc-banner {
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 14px;
        margin: 10px 0 12px;
      }
      .wuc-ic { width: 36px; height: 36px; min-width: 36px; font-size: 18px; }
      .wuc-content { flex: 1 1 calc(100% - 50px); }
      .wuc-title { font-size: 13px; }
      .wuc-sub { font-size: 11.5px; }
      .wuc-feats { display: none; }
      .wuc-price-block {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 4px;
      }
      .wuc-price { font-size: 18px; }
      .wuc-btn { padding: 9px 14px; font-size: 12px; }
    }

    /* Drawer (sempre stretto) */
    cart-drawer .wuc-banner,
    .cart-drawer .wuc-banner,
    .drawer--cart .wuc-banner {
      flex-wrap: wrap;
      gap: 8px;
      padding: 11px 13px;
      margin: 8px 0 10px;
      border-radius: 10px;
    }
    cart-drawer .wuc-ic,
    .cart-drawer .wuc-ic,
    .drawer--cart .wuc-ic {
      width: 32px; height: 32px; min-width: 32px;
      font-size: 16px; border-radius: 8px;
    }
    cart-drawer .wuc-content,
    .cart-drawer .wuc-content,
    .drawer--cart .wuc-content {
      flex: 1 1 calc(100% - 44px);
    }
    cart-drawer .wuc-title,
    .cart-drawer .wuc-title,
    .drawer--cart .wuc-title { font-size: 12.5px; }
    cart-drawer .wuc-sub,
    .cart-drawer .wuc-sub,
    .drawer--cart .wuc-sub { font-size: 11px; }
    cart-drawer .wuc-feats,
    .cart-drawer .wuc-feats,
    .drawer--cart .wuc-feats { display: none; }
    cart-drawer .wuc-price-block,
    .cart-drawer .wuc-price-block,
    .drawer--cart .wuc-price-block {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: 4px;
    }
    cart-drawer .wuc-price,
    .cart-drawer .wuc-price,
    .drawer--cart .wuc-price { font-size: 16px; }
    cart-drawer .wuc-btn,
    .cart-drawer .wuc-btn,
    .drawer--cart .wuc-btn {
      padding: 8px 14px; font-size: 11.5px;
    }
  `;
  // Compatto: due righe, uguali nel cassetto e nella pagina, da telefono e da
  // computer. Sopra: scudo, "Garanzia estesa 2 anni", X. Sotto: "Cosa copre",
  // prezzo, Aggiungi. I dettagli si aprono sotto solo se il cliente li chiede.
  // Su una riga sola, da telefono (343 px) andava a capo in tre punti.
  // Le regole hanno due classi (.wuc-banner.wuc-compatto) per stare sopra a
  // quelle del grande, anche a quelle del cassetto e del telefono.
  css += `
    .wuc-banner.wuc-compatto {
      display: grid;
      grid-template-columns: 22px 1fr auto auto;
      grid-template-areas:
        "ic titolo titolo x"
        ".  sotto  sotto  sotto"
        ".  info   prezzo btn"
        "det det   det    det";
      align-items: center;
      gap: 2px 10px;
      margin: 8px 0 12px;
      padding: 8px 10px 8px 14px;
      border-width: 1px;
      border-radius: 10px;
    }
    .wuc-compatto::before { width: 3px; }
    .wuc-compatto .wucc-ic { grid-area: ic; font-size: 17px; line-height: 1; }
    .wuc-compatto .wucc-titolo { grid-area: titolo; font-size: 13.5px; font-weight: 700; color: #1a1a1a; line-height: 1.3; min-width: 0; }
    .wuc-compatto .wucc-sotto { grid-area: sotto; font-size: 12px; color: #555; line-height: 1.35; min-width: 0; }
    /* Largo (pagina carrello da computer): prezzo e pulsante a destra, a
       fianco del testo, e il riquadro resta basso */
    .wuc-banner.wuc-compatto.wuc-largo {
      grid-template-columns: 22px 1fr auto auto 22px;
      grid-template-areas:
        "ic titolo prezzo btn x"
        ".  sotto  prezzo btn x"
        ".  info   prezzo btn x"
        "det det   det    det det";
      column-gap: 14px;
    }
    .wuc-largo .wucc-prezzo, .wuc-banner.wuc-largo .wuc-btn { align-self: center; }
    .wuc-banner.wuc-largo .wuc-dismiss { align-self: start; }
    .wuc-compatto .wucc-info {
      grid-area: info; justify-self: start;
      background: none; border: 0; padding: 0; margin: 0; min-height: 0; cursor: pointer;
      font-size: 12px; line-height: 1.3; color: #555; text-decoration: underline; text-underline-offset: 2px;
    }
    .wuc-compatto .wucc-prezzo { grid-area: prezzo; font-size: 14px; font-weight: 800; color: ${accentColor}; white-space: nowrap; }
    .wuc-banner.wuc-compatto .wuc-btn {
      grid-area: btn; margin: 0; min-height: 0; height: 32px; padding: 0 14px;
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 12px; line-height: 1; border-radius: 8px; white-space: nowrap;
    }
    .wuc-banner.wuc-compatto .wuc-dismiss {
      grid-area: x; position: static; justify-self: end;
      width: 22px; height: 22px; min-height: 0; border-color: #e0e0e0;
    }
    .wuc-banner.wuc-compatto .wuc-dismiss svg { width: 10px; height: 10px; }
    .wuc-compatto .wucc-dettagli { grid-area: det; font-size: 12px; color: #444; padding: 6px 0 2px; }
    .wuc-compatto .wucc-dettagli ul { margin: 0; padding-left: 18px; }
    .wuc-compatto .wucc-dettagli li { margin: 2px 0; }
  `;
  document.head.appendChild(Object.assign(document.createElement('style'), { textContent: css }));

  // ─── STATE ───
  var dismissed = {};
  try {
    var stored = sessionStorage.getItem('wuc_dismissed');
    if (stored) dismissed = JSON.parse(stored);
  } catch(e) {}
  function saveDismissed() {
    try { sessionStorage.setItem('wuc_dismissed', JSON.stringify(dismissed)); } catch(e) {}
  }

  // ─── FoxTheme pubsub ───
  function publishCartUpdate(cb) {
    var ft = window.FoxTheme;
    var url = ft && ft.routes && ft.routes.cart_url ? ft.routes.cart_url : '/cart.js';
    var opts = ft && ft.utils && typeof ft.utils.fetchConfig === 'function'
      ? Object.assign({}, ft.utils.fetchConfig())
      : { headers: { Accept: 'application/json' }, method: 'GET' };
    origFetch(url, opts)
      .then(function(r) { return r.json(); })
      .then(function(cartJson) {
        if (ft && ft.pubsub && ft.pubsub.publish && ft.pubsub.PUB_SUB_EVENTS) {
          ft.pubsub.publish(ft.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }
        if (cb) cb();
      })
      .catch(function() { if (cb) cb(); });
  }

  function refreshDrawer(cb) {
    var sectionId = getCartDrawerSection();
    if (!sectionId) { if (cb) cb(); return; }
    origFetch('/?sections=' + sectionId)
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections[sectionId];
        if (html) {
          var c = document.getElementById('shopify-section-' + sectionId);
          if (c) c.innerHTML = html;
        }
        if (cb) cb();
      })
      .catch(function() { if (cb) cb(); });
  }

  // ─── LEGAME GARANZIA ↔ PRODOTTO ───
  // La riga garanzia resta unica e raggruppata (niente proprieta' _parent, che
  // spezzerebbe la riga in due), quindi il legame col prodotto coperto vive
  // negli attributi del carrello, come gia' si fa con _alp_selected.
  // Formato: {"<variant_id prodotto>": "<variant_id garanzia>"}.
  // Serve solo a noi, per togliere la garanzia quando il prodotto esce dal
  // carrello e per tenerne allineata la quantita'. In ordine si vede una riga
  // sola: quante garanzie e di quale fascia, che e' quello che serve.
  var ATTR = '_wu_map';

  // Le scritture passano dalla catena condivisa con cart-services-sync.js:
  // due update contemporanei sullo stesso carrello si sovrascriverebbero.
  function inCoda(fn) {
    window.__svcCartChain = (window.__svcCartChain || Promise.resolve()).then(fn).catch(function () {});
    return window.__svcCartChain;
  }

  function leggiMappa(cart) {
    var grezzo = (cart.attributes && cart.attributes[ATTR]) || '';
    if (!grezzo) return {};
    try { return JSON.parse(grezzo) || {}; } catch (e) { return {}; }
  }

  function scriviMappa(mappa) {
    var attrs = {};
    attrs[ATTR] = Object.keys(mappa).length ? JSON.stringify(mappa) : '';
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  // Registra "questa garanzia copre quel prodotto", subito dopo l'aggiunta.
  function registraLegame(variantProdotto, variantGaranzia) {
    return inCoda(function () {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var mappa = leggiMappa(cart);
          mappa[String(variantProdotto)] = String(variantGaranzia);
          return scriviMappa(mappa);
        });
    });
  }
  window.__warrantyRegistraLegame = registraLegame;

  // Allinea le righe garanzia ai prodotti ancora in carrello.
  // Le garanzie senza legame registrato (carrelli nati prima di questa modifica)
  // non si toccano: meglio una garanzia di troppo che una tolta a sorpresa.
  function allineaGaranzie() {
    return inCoda(function () {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var mappa = leggiMappa(cart);
          if (!Object.keys(mappa).length) return;

          var qtaProdotti = {};
          cart.items.forEach(function (i) {
            if (warrantyVariantIds.has(String(i.variant_id))) return;
            var k = String(i.variant_id);
            qtaProdotti[k] = (qtaProdotti[k] || 0) + i.quantity;
          });

          // quante garanzie servono per ogni fascia, e ripulitura dei legami morti
          var attese = {}, mappaNuova = {}, mappaCambiata = false;
          Object.keys(mappa).forEach(function (vProdotto) {
            var vGaranzia = String(mappa[vProdotto]);
            var qta = qtaProdotti[vProdotto] || 0;
            if (qta > 0) {
              attese[vGaranzia] = (attese[vGaranzia] || 0) + qta;
              mappaNuova[vProdotto] = vGaranzia;
            } else {
              mappaCambiata = true;
            }
          });

          var updates = {}, daCambiare = 0;
          cart.items.forEach(function (i) {
            var v = String(i.variant_id);
            if (!warrantyVariantIds.has(v)) return;
            if (!(v in attese) && !mappaCambiata) return;
            var voluta = attese[v] || 0;
            if (i.quantity !== voluta) { updates[i.key] = voluta; daCambiare++; }
          });

          if (!daCambiare && !mappaCambiata) return;

          var body = {};
          if (daCambiare) body.updates = updates;
          if (mappaCambiata) {
            body.attributes = {};
            body.attributes[ATTR] = Object.keys(mappaNuova).length ? JSON.stringify(mappaNuova) : '';
          }
          dbg('Allineo garanzie', body);
          return origFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (res) {
            // se ho tolto o cambiato righe la pagina carrello va rinfrescata
            if (res && res.ok && daCambiare && window.location.pathname.indexOf('/cart') !== -1) {
              window.location.reload();
            }
          });
        });
    });
  }
  window.__warrantyAllinea = allineaGaranzie;

  // ─── ANALYZE CART ───
  function analyzeCart(cartData) {
    var eligible = [];
    var warrantyInCart = new Set();

    cartData.items.forEach(function(item) {
      if (warrantyVariantIds.has(String(item.variant_id))) {
        warrantyInCart.add(String(item.variant_id));
      }
    });

    cartData.items.forEach(function(item) {
      if (warrantyVariantIds.has(String(item.variant_id))) return;
      if (isExcludedType(item.product_type)) return;
      var price = item.price / 100;
      if (price <= 0) return;
      if (price < (config.min_price || 0)) return;   // sotto soglia niente garanzia (min_price nello snippet)
      var tier = findTier(price);
      if (!tier) return;
      if (warrantyInCart.has(String(tier.variant_id))) return;
      var key = item.variant_id + '-' + tier.variant_id;
      if (dismissed[key]) return;
      eligible.push({ item: item, tier: tier, key: key });
    });

    return eligible;
  }

  // ─── TRACCIAMENTO ───
  // Quanti vedono il riquadro nel carrello e quanti aggiungono la garanzia
  // (Danilo, 24/09). Su PostHog tre eventi, sempre con le stesse proprieta'
  // (dove, stile, prodotto, fascia): "Garanzia Carrello Mostrata" una volta
  // per riquadro e per pagina, "... Aggiunta", "... Chiusa". PostHog li riceve
  // solo da chi accetta i cookie: il rapporto aggiunte/mostrate e' pulito, i
  // numeri assoluti no. Per questo l'aggiunta va anche a GA4 come add_to_cart
  // (lista "Garanzia (carrello)"), che conta tutti.
  var giaMostrati = {};
  function datiGaranzia(e, dove) {
    return {
      dove: dove === 'drawer' ? 'cassetto' : 'carrello',
      stile: compatto ? 'compatto' : 'grande',
      prodotto: e.item.handle,
      prezzo_prodotto: e.item.price / 100,
      fascia: e.tier.sku || String(e.tier.variant_id),
      prezzo_garanzia: e.tier.price
    };
  }
  function tracciaGaranzia(nome, dati) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(nome, dati);
    } catch (x) {}
  }
  function tracciaMostrata(e, dove, el) {
    // nel cassetto chiuso il riquadro c'e' ma non si vede: conta quando si apre
    if (!el.getBoundingClientRect().width) return;
    if (giaMostrati[e.key + '|' + dove]) return;
    giaMostrati[e.key + '|' + dove] = true;
    tracciaGaranzia('Garanzia Carrello Mostrata', datiGaranzia(e, dove));
  }

  // ─── ALLINEAMENTO (compatto) ───
  // Il riquadro sta sotto la riga del prodotto: dove c'e' spazio parte dalla
  // colonna del nome, non da sotto la foto (Danilo, 24/09). Da telefono la
  // colonna del nome e' larga ~230 px e non ci starebbe: li' resta a tutta
  // larghezza. Si ricalcola quando la riga cambia misura (il cassetto chiuso
  // ha misure zero finche' non si apre).
  var MIN_COLONNA = 280, MIN_LARGO = 460;
  function allinea(banner, line) {
    function calcola() {
      if (!banner.isConnected) return;
      var lr = line.getBoundingClientRect();
      if (!lr.width) return;
      var info = line.querySelector('.cart-item__product--info, .cart-item__details, .cart-item__info');
      var media = line.querySelector('.cart-item__media');
      var x = info ? info.getBoundingClientRect().left : (media ? media.getBoundingClientRect().right + 12 : lr.left);
      var spostamento = Math.max(0, Math.round(x - lr.left));
      if (spostamento && lr.width - spostamento >= MIN_COLONNA) {
        banner.style.marginLeft = spostamento + 'px';
        banner.style.width = 'calc(100% - ' + spostamento + 'px)';
      } else {
        banner.style.marginLeft = '';
        banner.style.width = '';
      }
      banner.classList.toggle('wuc-largo', banner.getBoundingClientRect().width >= MIN_LARGO);
    }
    calcola();
    if (window.ResizeObserver) {
      try { new ResizeObserver(calcola).observe(line); } catch (e) {}
    }
  }

  (function () {
    var cassetto = document.querySelector('cart-drawer');
    if (!cassetto || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!cassetto.hasAttribute('open')) return;
      setTimeout(function () {
        Array.prototype.forEach.call(cassetto.querySelectorAll('.wuc-banner'), function (b) {
          if (b.__wuc) tracciaMostrata(b.__wuc.e, b.__wuc.dove, b);
        });
      }, 400);
    }).observe(cassetto, { attributes: true, attributeFilter: ['open'] });
  })();

  // ─── BANNER CREATION ───
  function createBanner(eligible, dove) {
    var item = eligible.item;
    var tier = eligible.tier;
    var key = eligible.key;
    var duration = tier.duration || '3 anni';

    var banner = document.createElement('div');
    banner.className = 'wuc-banner';
    banner.setAttribute('data-wuc-key', key);

    var features = (tier.features || []).slice(0, 3);
    var featsHtml = features.length
      ? '<div class="wuc-feats">' + features.map(function(f) {
          return '<span class="wuc-feat">' + escHtml(f) + '</span>';
        }).join('') + '</div>'
      : '';

    var testoBottone = compatto ? 'Aggiungi' : '🛡️ Aggiungi garanzia';
    if (compatto) {
      banner.className = 'wuc-banner wuc-compatto';
      var dettagli = (tier.features || []).slice(0, 3).concat(['Massimale ' + fp(tier.max_price) + ' sul valore del prodotto']);
      // Sottotitolo dalle caratteristiche della fascia, cosi' resta vero anche
      // se Garanzia3 cambia le condizioni: cosa fa + fino a quanto copre.
      var cosaFa = (tier.features || []).filter(function (f) { return /riparaz|sostituz/i.test(f); })[0]
        || 'Protezione da guasti e malfunzionamenti';
      var sottotitolo = cosaFa + ', copertura fino a ' + fp(tier.max_price);
      banner.innerHTML =
        '<span class="wucc-ic" aria-hidden="true">🛡️</span>' +
        '<div class="wucc-titolo">Estendi la garanzia di ' + escHtml(duration) + '</div>' +
        '<div class="wucc-sotto">' + escHtml(sottotitolo) + '</div>' +
        '<button type="button" class="wuc-dismiss" title="Non aggiungere garanzia" aria-label="Chiudi messaggio estensione garanzia">' +
          '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 2 L10 10 M10 2 L2 10"/></svg>' +
        '</button>' +
        '<button type="button" class="wucc-info" aria-expanded="false">Cosa copre</button>' +
        '<span class="wucc-prezzo">' + fp(tier.price) + '</span>' +
        '<button type="button" class="wuc-btn">' + testoBottone + '</button>' +
        '<div class="wucc-dettagli" hidden><ul>' + dettagli.map(function (f) { return '<li>' + escHtml(f) + '</li>'; }).join('') + '</ul></div>';
      var info = banner.querySelector('.wucc-info');
      info.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var box = banner.querySelector('.wucc-dettagli');
        var apri = box.hasAttribute('hidden');
        if (apri) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
        info.setAttribute('aria-expanded', apri ? 'true' : 'false');
        info.textContent = apri ? 'Chiudi' : 'Cosa copre';
      };
    } else
    banner.innerHTML =
      '<button type="button" class="wuc-dismiss" title="Non aggiungere garanzia" aria-label="Chiudi messaggio estensione garanzia">' +
        '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 2 L10 10 M10 2 L2 10"/></svg>' +
      '</button>' +
      '<div class="wuc-ic">🛡️</div>' +
      '<div class="wuc-content">' +
        '<div class="wuc-title">Garanzia Estesa ' + escHtml(duration) + ' — Massimale ' + fp(tier.max_price) + '</div>' +
        '<div class="wuc-sub">Proteggi il tuo acquisto da guasti e malfunzionamenti</div>' +
        featsHtml +
      '</div>' +
      '<div class="wuc-price-block">' +
        '<div class="wuc-price">' + fp(tier.price) + '</div>' +
        '<button type="button" class="wuc-btn">🛡️ Aggiungi garanzia</button>' +
      '</div>';

    // Click su Aggiungi
    var btn = banner.querySelector('.wuc-btn');
    btn.onclick = function(e) {
      e.stopPropagation();
      e.preventDefault();
      btn.disabled = true;
      btn.textContent = 'Aggiungendo...';

      origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(tier.variant_id), quantity: item.quantity }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        registraLegame(item.variant_id, tier.variant_id);
        tracciaGaranzia('Garanzia Carrello Aggiunta', datiGaranzia(eligible, dove));
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'EUR',
              value: tier.price * item.quantity,
              items: [{ item_id: tier.sku || String(tier.variant_id), item_name: 'Garanzia estesa ' + (tier.duration || ''),
                        item_brand: 'Garanzia3', price: tier.price, quantity: item.quantity,
                        item_list_name: 'Garanzia (carrello)' }]
            },
            event_id: 'wuc_' + Date.now()
          });
        } catch (x) {}
        // Stato visivo "aggiunta"
        banner.classList.add('wuc-banner-added');
        banner.innerHTML =
          '<div class="wuc-added-msg">' +
            '<span class="wuc-added-check">✓</span>' +
            'Garanzia aggiunta al carrello' +
          '</div>';

        // Verifica se siamo nella cart page o nel drawer
        var inCartPage = window.location.pathname.indexOf('/cart') !== -1;

        if (inCartPage) {
          // Nella cart page: ricarica la pagina per aggiornare i totali
          setTimeout(function() { window.location.reload(); }, 800);
        } else {
          // Nel drawer: aggiorna via section rendering e RIAPRI il drawer
          publishCartUpdate(function() {
            refreshDrawer(function() {
              // Riapri il drawer dopo il refresh
              setTimeout(function() {
                var drawer = document.querySelector('cart-drawer');
                if (drawer && typeof drawer.show === 'function') {
                  drawer.show();
                }
                injectButtons();
              }, 100);
            });
          });
        }
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = testoBottone;
      });
    };

    // Click su dismiss
    var dismissBtn = banner.querySelector('.wuc-dismiss');
    dismissBtn.onclick = function(e) {
      e.stopPropagation();
      e.preventDefault();
      dismissed[key] = true;
      tracciaGaranzia('Garanzia Carrello Chiusa', datiGaranzia(eligible, dove));
      saveDismissed();
      banner.style.opacity = '0';
      banner.style.transform = 'translateY(-4px)';
      banner.style.transition = 'all .25s ease';
      setTimeout(function() {
        banner.style.height = banner.offsetHeight + 'px';
        requestAnimationFrame(function() {
          banner.style.height = '0';
          banner.style.padding = '0';
          banner.style.margin = '0';
          banner.style.borderWidth = '0';
          banner.style.overflow = 'hidden';
        });
        setTimeout(function() { banner.remove(); }, 250);
      }, 250);
    };

    return banner;
  }

  // ─── FIND LINE ELEMENTS ───
  function getAllCartLines(container) {
    if (!container) return [];

    // Lista di selettori da provare in ordine
    var selectors = [
      '.cart-drawer__items > *',
      '.cart-drawer__item',
      '.cart-items__item',
      '.cart-item',
      '[data-cart-item]',
      '.drawer__item',
      'tr.cart-item',
      '.cart__row',
      'cart-drawer-items > *',
      '.line-item',
      'li.cart__item'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var els = container.querySelectorAll(selectors[i]);
      if (els.length > 0) {
        dbg('Found', els.length, 'cart lines with selector:', selectors[i]);
        return Array.from(els);
      }
    }

    // Fallback: cerca elementi che contengono link a /products/
    var allLinks = container.querySelectorAll('a[href*="/products/"]');
    var lines = [];
    var seen = new Set();
    allLinks.forEach(function(link) {
      var parent = link.closest('li, tr, .cart-item, [class*="cart"], [class*="line"], [class*="item"]');
      if (parent && !seen.has(parent)) {
        seen.add(parent);
        lines.push(parent);
      }
    });
    if (lines.length > 0) {
      dbg('Fallback: found', lines.length, 'cart lines via product links');
      return lines;
    }

    dbg('No cart lines found in container');
    return [];
  }

  function findLineForItem(lines, item) {
    var vid = String(item.variant_id);
    var handle = item.handle;
    var title = item.product_title;

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];

      // Per data-variant-id o data-key
      if (line.getAttribute('data-variant-id') === vid) return line;
      if (line.getAttribute('data-key') && line.getAttribute('data-key').indexOf(vid) === 0) return line;

      // Per link al prodotto
      if (handle && line.querySelector('a[href*="/products/' + handle + '"]')) return line;

      // Per input nascosto
      if (line.querySelector('[name*="updates["][name*="' + vid + '"]')) return line;
      if (line.querySelector('input[value="' + vid + '"]')) return line;
    }

    // Fallback: per titolo
    for (var j = 0; j < lines.length; j++) {
      if (lines[j].textContent.indexOf(title) !== -1) return lines[j];
    }

    return null;
  }

  // ─── INJECT BUTTONS ───
  function injectButtons() {
    origFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var eligible = analyzeCart(cart);
        dbg('Cart items:', cart.items.length, '— Eligible for warranty:', eligible.length);

        // Mappa delle key idonee correnti
        var currentKeys = new Set();
        eligible.forEach(function(e) { currentKeys.add(e.key); });

        // Rimuovi solo i banner non più validi (es. garanzia ora aggiunta, dismissed, ecc.)
        document.querySelectorAll('[data-wuc-key]').forEach(function(el) {
          var k = el.getAttribute('data-wuc-key');
          if (!currentKeys.has(k)) el.remove();
        });

        if (eligible.length === 0) return;

        var containers = [];
        var _sid = getCartDrawerSection();
        var drawerContainer = _sid ? document.getElementById('shopify-section-' + _sid) : null;
        if (drawerContainer) containers.push({ el: drawerContainer, name: 'drawer' });

        var cartPage = document.querySelector('main, #MainContent, [role="main"]');
        if (cartPage && window.location.pathname.indexOf('/cart') !== -1) {
          containers.push({ el: cartPage, name: 'cart-page' });
        }

        if (containers.length === 0) {
          dbg('No containers found');
          return;
        }

        containers.forEach(function(ctx) {
          var lines = getAllCartLines(ctx.el);
          dbg('Container:', ctx.name, '— Lines found:', lines.length);
          if (lines.length === 0) return;

          eligible.forEach(function(e) {
            // Verifica se il banner per questa key esiste GIÀ in questo container
            if (ctx.el.querySelector('[data-wuc-key="' + e.key + '"]')) {
              return; // Già presente, non re-inserire
            }

            var line = findLineForItem(lines, e.item);
            if (!line) {
              dbg('No line found for', e.item.product_title);
              return;
            }

            var banner = createBanner(e, ctx.name);
            line.parentNode.insertBefore(banner, line.nextSibling);
            if (compatto) allinea(banner, line);
            banner.__wuc = { e: e, dove: ctx.name };
            tracciaMostrata(e, ctx.name, banner);
            dbg('Injected banner for', e.item.product_title, 'in', ctx.name);
          });
        });
      })
      .catch(function(err) { dbg('Error:', err); });
  }

  // ─── OBSERVERS ───
  function setupDrawerObserver() {
    var sectionId = getCartDrawerSection();
    if (!sectionId) return;
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section || section.__wucObserved) return;
    section.__wucObserved = true;

    var obs = new MutationObserver(function(mutations) {
      // Ignora mutazioni causate dai nostri banner
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        // Se la mutazione è dentro un nostro banner, skip
        if (m.target && m.target.closest && m.target.closest('[data-wuc-key]')) continue;
        // Se i nodi aggiunti/rimossi sono nostri banner, skip
        var allOurs = true;
        var nodes = [].concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []));
        if (nodes.length === 0) {
          // Mutazione di attributi sul drawer stesso → rilevante (es. open)
          relevant = true;
          break;
        }
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].nodeType === 1 && !nodes[j].hasAttribute('data-wuc-key')) {
            allOurs = false;
            break;
          }
        }
        if (!allOurs) {
          relevant = true;
          break;
        }
      }

      if (!relevant) return;

      clearTimeout(section.__wucT);
      section.__wucT = setTimeout(function() {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        var cs = getComputedStyle(drawer);
        var visible = cs.visibility === 'visible' && cs.opacity !== '0' && cs.display !== 'none';
        if (visible || drawer.classList.contains('is-open') || drawer.classList.contains('active') || drawer.classList.contains('drawer--is-open')) {
          dbg('Drawer mutation detected (relevant), drawer visible');
          injectButtons();
        }
      }, 500);
    });
    obs.observe(section, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class', 'style', 'aria-hidden']
    });
    dbg('Drawer observer setup');
  }

  // Setup iniziale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDrawerObserver);
  } else {
    setupDrawerObserver();
  }

  // Click su icona carrello
  document.addEventListener('click', function(e) {
    var t = e.target.closest('a[href="/cart"], [data-cart-toggle], .cart-icon-bubble, .header__icon--cart, .js-drawer-open-cart, [aria-controls*="cart-drawer"]');
    if (t) {
      dbg('Cart icon click detected');
      setTimeout(injectButtons, 600);
      setTimeout(injectButtons, 1200);
    }
  });

  // Cart page: inietta al caricamento
  if (window.location.pathname.indexOf('/cart') !== -1) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(injectButtons, 500); });
    } else {
      setTimeout(injectButtons, 500);
    }
  }

  // Eventi cart update
  ['cart:updated', 'cart:refresh'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      allineaGaranzie();
      setTimeout(injectButtons, 500);
    });
  });

  // FoxTheme pubsub cartUpdate
  function attachFoxThemeListener() {
    if (window.__wucFoxAttached) return;
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      window.__wucFoxAttached = true;
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function() {
        dbg('FoxTheme cartUpdate received');
        allineaGaranzie();
        setTimeout(injectButtons, 400);
      });
      dbg('FoxTheme pubsub attached');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachFoxThemeListener);
  } else {
    attachFoxThemeListener();
  }
  setTimeout(attachFoxThemeListener, 500);
  setTimeout(attachFoxThemeListener, 1500);

  // Espone funzione per debug manuale
  window.__warrantyCartInject = injectButtons;

  console.log('[WarrantyCart] v5 ready (' + tiers.length + ' tiers). Per debug: window.__warrantyCartDebug = true; window.__warrantyCartInject();');
})();